// QuickBooks Service - Orchestrator that delegates to focused modules
import { exchangeCodeForToken, refreshAccessToken } from './auth/tokenManager';
import { saveConnectionInfo, getConnectionInfo, hasConnection, disconnect } from './auth/connectionManager';
import { makeQBApiCall } from './api/qbApiClient';
import { getAllCustomers, getQuickBooksCustomerCount, importCustomers } from './operations/customerOperations';
import { downloadInvoicePDF } from './operations/invoiceOperations';

class QuickBooksService {
  
  // OAuth Token Management
  async exchangeCodeForToken(code, state, realmId) {
    return exchangeCodeForToken(code, state, realmId);
  }

  async refreshAccessToken(refreshToken) {
    return refreshAccessToken(refreshToken);
  }

  // Connection Management  
  async saveConnectionInfo(franchiseeId, tokenInfo) {
    return saveConnectionInfo(franchiseeId, tokenInfo);
  }

  async getConnectionInfo(franchiseeId) {
    return getConnectionInfo(franchiseeId);
  }

  async hasConnection(franchiseeId) {
    return hasConnection(franchiseeId);
  }

  async disconnect(franchiseeId) {
    return disconnect(franchiseeId);
  }

  // API Communication
  async makeQBApiCall(accessToken, companyId, endpoint, params = {}) {
    return makeQBApiCall(accessToken, companyId, endpoint, params);
  }

  // Customer Operations
  async getAllCustomers(franchiseeId) {
    return getAllCustomers(franchiseeId);
  }

  async getQuickBooksCustomerCount(franchiseeId) {
    return getQuickBooksCustomerCount(franchiseeId);
  }

  async importCustomers(franchiseeId, userId, progressCallback = null) {
    return importCustomers(franchiseeId, userId, progressCallback);
  }

  // Invoice Operations
  async downloadInvoicePDF(franchiseeId, qbInvoiceId) {
    return downloadInvoicePDF(franchiseeId, qbInvoiceId);
  }
}

const quickBooksService = new QuickBooksService();
export default quickBooksService;